import { Button } from '@telegram-apps/telegram-ui'
import { FunnelX, PackageOpen } from 'lucide-react'
import { useTranslate } from 'shared/lib/i18n'

export function FeedEmptyState({
	filtered,
	onReset,
}: {
	/** True when search/chip filters are active (vs a genuinely empty catalog). */
	filtered: boolean
	onReset: () => void
}) {
	const { prefixT } = useTranslate('pages.feed')
	return (
		<div className='flex flex-col items-center gap-2 px-10 py-14 text-center'>
			<div className='mb-1.5 grid size-[76px] place-items-center rounded-full bg-[var(--tgui--tertiary_bg_color,rgb(42,42,42))] text-[var(--tgui--hint_color,rgb(170,170,170))]'>
				<PackageOpen className='size-8' />
			</div>
			<div className='text-[19px] font-semibold text-[var(--tgui--text_color,#fff)]'>
				{filtered ? prefixT('nothingFound') : prefixT('noLots')}
			</div>
			<div className='max-w-60 text-[15px] leading-snug text-[var(--tgui--hint_color,rgb(170,170,170))]'>
				{filtered ? prefixT('changeFilters') : prefixT('comeBackLater')}
			</div>
			{filtered && (
				<Button mode='bezeled' size='s' className='mt-2' onClick={onReset}>
					<div className='flex flex-row items-center gap-1'>
						<FunnelX className='size-6' />
						{prefixT('resetFilters')}
					</div>
				</Button>
			)}
		</div>
	)
}
